// Sports Name Configuration
const nameConfigs = {
    NCAAM: ['School'],
    NCAAW: ['School'],
    NBA: ['Key', 'Name'],  // Supports multiple properties
    NHL: ['Key', 'Name'],  // Supports multiple properties
};

// Modified getTeamName function with special handling for LA teams
export const getTeamName = (league, teamId, teams) => {
    // Early return check with detailed logging
    if (!teams || !league || !teamId) {
        return null;
    }
    
    const propertyNames = nameConfigs[league];
    
    if (!propertyNames || !propertyNames.length) {
        return null;
    }
    
    const team = teams?.find(team => team.GlobalTeamID === teamId);
    
    if (!team) {
        return null;
    }
    
    // Special handling for NBA LA teams
    if (league === 'NBA' && team.Key && team.Key.startsWith('LA')) {
        // Get just "LA" for LA teams and combine with the Name property
        return `LA ${team.Name}`;
    }

    // Special handling for NHL NY teams
    if (league === 'NHL' && team.Key && team.Key.startsWith('NY')) {
        // Get just "NY" for NY teams and combine with the Name property
        return `NY ${team.Name}`;
    }
    
    // If only one property is configured (like for NCAAM/NCAAW), return that value
    if (propertyNames.length === 1) {
        return team[propertyNames[0]];
    }
    
    // For multiple properties (like NBA), join them with a space
    // Only include properties that actually exist on the team object
    return propertyNames
        .map(prop => team[prop])
        .filter(value => value !== undefined && value !== null)
        .join(' ');
};